import { z } from 'zod';

const SLUG = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

/** Form behind POST /applications/:id/approve; the mapper omits blank optional fields. */
export const approveSchema = z.object({
  slug: z
    .string()
    .trim()
    .min(1, { error: 'applications:validation.required' })
    .max(120, { error: 'applications:validation.tooLong' })
    .regex(SLUG, { error: 'applications:validation.slugFormat' }),
  storeName: z.string().trim().max(120, { error: 'applications:validation.tooLong' }),
  currency: z
    .string()
    .trim()
    .toUpperCase()
    .refine((v) => v === '' || /^[A-Z]{3}$/.test(v), {
      error: 'applications:validation.currency',
    }),
  country: z
    .string()
    .trim()
    .toUpperCase()
    .refine((v) => v === '' || /^[A-Z]{2}$/.test(v), { error: 'applications:validation.country' }),
  timezone: z.string().min(1, { error: 'applications:validation.required' }),
  sendInvite: z.boolean(),
});

export type ApproveInput = z.input<typeof approveSchema>;
export type ApproveOutput = z.output<typeof approveSchema>;
